/* Generated by scripts/apply-brand.js — do not edit by hand */
/** Every brand folder under brands/. */
export const BRAND_IDS = ["dentistryq","gpqbank","icmqs","mastersrh","medicineqs","ogqbank","ophthalmologyq","psychqs","solicitorqs","surgeryqs"] as const;
export type BrandId = (typeof BRAND_IDS)[number];

/** CRA inlines this at build time; falls back to brand.marketingUrl when unset. */
export const marketingUrlFromEnv: string | undefined = process.env.REACT_APP_MARKETING_URL_SOLICITORQS;

export const brand = {
  id: "solicitorqs",
  displayName: "SolicitorQs",
  appUrl: "https://app.solicitorqs.com",
  marketingUrl: "https://solicitorqs.com",
  contactEmail: "solicitorqs@gmail.com",
  metaDescription: "SQE1 question bank for aspiring solicitors: exam-style single best answer questions with clear explanations, analytics and timed practice.",
  footerDescriptionHtml: "<strong>SQE1 question bank</strong> for aspiring solicitors in England and Wales: exam-style questions, clear explanations and timed practice.",
  signupKeyFeatures: ["Exam-style SQE1 single best answer questions","Clear explanations for every option","Analytics to target weak areas of the FLK1 and FLK2 syllabus","Timed practice under exam conditions"],
  s3Bucket: "app.solicitorqs.com",
  productIds: ["sqe1"],
  colors: {
    primary: "#23395b",
    primaryHover: "#18273e",
    navy: "#152337",
    navyDeep: "#0e1725",
    navyMid: "#1e304d",
    accent: "#29426a",
    accentAlt: "#2e4b78",
    stats: "#23395b",
    statsHover: "#1e304d",
    footer: "#152337",
    footerDeep: "#0e1725",
    footerLight: "#1e304d",
    footerMuted: "#090e16",
  },
} as const;

export type Brand = typeof brand;
